module.exports = __webpack_public_path__ + "static/media/P200-Plunger.815f69e6.svg";